import { createTheme } from '@mui/material/styles';

// Clean dark theme with monospace fonts
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ffffff',
      light: '#f5f5f5',
      dark: '#e0e0e0',
    },
    secondary: {
      main: '#888888',
      light: '#aaaaaa',
    },
    background: {
      default: '#0a0a0a',
      paper: '#151515',
    },
    text: {
      primary: '#ffffff',
      secondary: '#888888',
    },
    divider: '#333333',
  },
  typography: {
    fontFamily: '"IBM Plex Mono", "JetBrains Mono", "Courier New", monospace',
    h1: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '2.5rem',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1rem',
      lineHeight: 1.7,
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '0.875rem',
      lineHeight: 1.6,
      fontWeight: 400,
    },
    button: {
      fontFamily: '"IBM Plex Mono", monospace',
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#0a0a0a',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '10px 24px',
        },
      },
    },
  },
});

// Light theme option
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#000000',
      light: '#333333',
      dark: '#000000',
    },
    secondary: {
      main: '#666666',
      light: '#888888',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
    divider: '#e0e0e0',
  },
  typography: {
    fontFamily: '"IBM Plex Mono", "JetBrains Mono", "Courier New", monospace',
    h1: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '2.5rem',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '1rem',
      lineHeight: 1.7,
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '0.875rem',
      lineHeight: 1.6,
      fontWeight: 400,
    },
    button: {
      fontFamily: '"IBM Plex Mono", monospace',
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#ffffff',
          color: '#000000',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '10px 24px',
        },
      },
    },
  },
});

// Export old names for compatibility
export const terminalGreenTheme = darkTheme;
export const terminalAmberTheme = lightTheme;
